<template>
  <div>
    <!-- '待跟进物流列表' -->
    <div class="breadcrumb">
      <baseBreadcrumb :page="$t('message.pendingFollowUpLogisticsList')" :menu="$t('message.inspectionOfGoods')" />
      <div class="text annotation">（1688已签收但我们系统未收到货）</div>
    </div>

    <div class="body">
      <div class="search">
        <!-- 筛选 -->
        <div class="row">
          <!--请输入物流号 -->
          <div class="item">
            <el-input v-model="datas.express_no" clearable onfocus="this.select()"
              :placeholder="$t('message.pleaseEnterTheLogisticsNumber')"></el-input>
          </div>
          <div class="item">
            <!--请输入交易号 -->
            <div class="item">
              <el-input v-model="datas.purchase_no" clearable onfocus="this.select()"
                :placeholder="$t('message.pleaseEnterTransactionNumber')"></el-input>
            </div>
          </div>
          <!--客户ID -->
          <div class="item">
            <el-input v-model="datas.user_id" clearable onfocus="this.select()"
              :placeholder="$t('message.clientID')"></el-input>
          </div>
          <!--订单号 -->
          <div class="item">
            <el-input v-model="datas.order_sn" clearable onfocus="this.select()"
              :placeholder="$t('message.orderNumber')"></el-input>
          </div>
        </div>
        <!-- 筛选 -->
        <div class="row" style="margin-top:20px">
          <!-- 采购 -->
          <div class="item">
            <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
              <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 业务 -->
          <div class="item">
            <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
              <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 配货员 -->
          <div class="item">
            <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
              <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!--人员范围-->
          <div class="item">
            <!--  人员范围-->
            <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
          </div>
          <div class="item">
            <!--  全体人员-->
            <el-select v-model="datas.admin_id" :placeholder="$t('message.specificPersonnel')" filterable clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <!-- 搜索 -->
            <el-button type="primary" @click="search">{{
              $t("message.search")
            }}</el-button>
            <!-- 重置 -->
            <el-button @click="reset">{{
              $t("message.reset")
            }}</el-button>
          </div>
        </div>
      </div>
      <!-- 未到货订单列表 -->
      <div class="table">
        <ol>
          <!-- NO -->
          <li class="flex05">NO</li>
          <!-- 选择 -->
          <li class="flex05">{{ $t('message.choose') }}</li>
          <!--店铺信息  -->
          <li>{{ $t('message.storeInformation') }}</li>
          <!-- 照片 -->
          <li>{{ $t('message.pic') }}</li>
          <!-- 业务编辑商品属性 -->
          <li class="flex15">{{ $t('message.theBusinessEditsTheCommodityProperties') }}</li>
          <!-- 整番数量 -->
          <li>{{ $t('message.wholeRoundQuantity') }}</li>
          <!-- 当前价格 -->
          <li>{{ $t('message.currentPrice') }}</li>
          <!-- 采购完成时间 -->
          <li>{{ $t('message.purchaseCompletionTime') }}</li>
          <!-- 交易号/物流号 -->
          <li class="flex2">{{ $t('message.transactionNumberLogisticsNumber') }}</li>
          <!-- 业务商品备注 -->
          <li class="flex15">{{ $t('message.salesmanCommodityRemarks') }}</li>
          <!-- 业务跟单备注 -->
          <li class="flex15">{{ $t('message.businessFollowUpRemarks') }}</li>
          <!-- 采购商品备注 -->
          <li class="flex15">{{ $t('message.remarksForPurchasedCommodities') }}</li>
          <!-- 采购跟单备注 -->
          <li class="flex15">{{ $t('message.purchaseDocumentaryRemarks') }}</li>
          <!-- 配货商品备注 -->
          <li class="flex15">{{ $t('message.deliveryProductRemarks') }}</li>
          <!-- 状态 -->
          <li>{{ $t('message.status') }}</li>
        </ol>
        <!-- 物流 -->
        <div class="express" v-for="(express, expressIndex) in tableData" :key="expressIndex">
          <!-- 物流号 -->
          <div class="express-head">
            <div class="item express_no">
              {{ $t('message.logisticsNumber') }}: <span @click="expressStatusReal(express.express_no, expressIndex)"
                title="点击查看物流号发货、收货时间">{{
                  express.express_no }}</span>
              <!-- 复制 -->
              <i class="el-icon-copy-document" @click="copy(express.express_no)"></i>
              <span class="annotation"> (系统未签收)</span>

            </div>
            <!-- 物流号发货时间 -->
            <div class="item">
              <span>{{ $t('message.logisticsDeliveryTime') }}：</span> {{ express.send_time }}
            </div>
            <!-- 物流号1688签收时间 -->
            <div class="item">
              <span>{{ $t('message.logistics1688SignTime') }}：</span> {{ express.receive_time }}
            </div>

          </div>
          <!-- 订单详情 -->
          <div class="detail" v-for="(item, index) in express.items" :key="index">
            <div class="head">
              <!-- 选择 -->
              <div class="item">
                <el-checkbox v-model="item.checked" @change="changeChecked(item)">
                </el-checkbox>
              </div>
              <!-- 订单号/客户ID/客户姓名/客户属性 -->
              <div class="item order">
                <div class="template">
                  <div class="row">
                    <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank">
                      {{ item.order_sn }}
                    </router-link>
                    <i class="el-icon-copy-document" @click="copy(item.order_sn)"></i>
                  </div>
                  <div class="row">
                    <!-- 客户名 -->
                    <span style="margin-right: 10px;">
                      {{ item.user.realname }}
                    </span>
                    <!-- 客户属性 -->
                    <div style="width: 100px;">
                      <attributeName :name="item.client_attribute.name" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- 业务  -->
              <div class="item name">
                <div class="template">
                  <!-- 业务： -->
                  <div class="row">{{ $t('message.business') }}: {{ item.yAdmin ? item.yAdmin.realname : '' }} </div>
                </div>
              </div>
              <!-- 采购  -->
              <div class="item name">
                <div class="template">
                  <!-- 采购： -->
                  <div class="row">{{ $t('message.purchase') }}: {{ item.gAdmin ? item.gAdmin.realname : '' }} </div>
                </div>
              </div>
              <!-- 配货  -->
              <div class="item name">
                <div class="template">
                  <!-- 配货： -->
                  <div class="row">{{ $t('message.distribution') }} : {{ item.pAdmin ? item.pAdmin.realname : '' }}
                  </div>
                </div>
              </div>
            </div>
            <ul v-for="(order, orderIndex) in item.order_detail" :key="orderIndex">
              <!-- NO -->
              <li class="flex05">{{ order.sorting }}</li>
              <!-- 选择 -->
              <li class="flex05">
                <el-checkbox v-model="order.checked" @change="orderChangeChecked(item, order)">
                </el-checkbox>
              </li>
              <!--店铺信息  -->
              <li>
                <div class="template">
                  <!-- 店铺名称： -->
                  <div class="row">{{ order.shop_name }} </div>
                  <!-- 店铺地址： -->
                  <div class="row">{{ order.from_platform }}({{ (order.service_rate * 100).toFixed(1) }}%) </div>
                  <!-- 店铺地址： -->
                  <div class="row">{{ order.shop_id }} </div>
                </div>
              </li>
              <!-- 照片 -->
              <li>
                <el-popover placement="right" width="300" trigger="hover">
                  <img :src="order.pic" alt="" style="width: 300px; height: 300px" />
                  <a :href="order.link" target="_blank" slot="reference">
                    <img :src="order.pic" alt="" style="width: 70px; height: 70px; border-radius: 4px;" />
                  </a>
                </el-popover>
                <!-- <el-image :src="order.pic" fit="fill" style="width: 70px; height: 70px; border-radius: 4px;"
                :preview-src-list="[order.pic]" /> -->
              </li>
              <!-- 业务编辑商品属性 -->
              <li class="flex15">
                <div class="template">
                  <div class="row" v-for="(detail, detailIndex) in order.detail_y" :key="detailIndex">
                    {{ detail.key }}：{{ detail.value }}
                  </div>
                </div>
              </li>
              <!-- 整番数量 -->
              <li>
                <div class="template">
                  <!-- 可入库  -->
                  <div class="row">{{ $t('message.canBePutIntoStorage') }}:{{ order.possible_num }}</div>
                  <!-- 已到货 -->
                  <div class="row">{{ $t('message.itHasArrived') }}:{{ order.storage_num }}</div>
                </div>
              </li>
              <!-- 当前价格 -->
              <li>
                <div class="template">
                  <!-- 单价  -->
                  <div class="row">{{ $t('message.unitPrice') }}:{{ order.confirm_price }}</div>
                  <!-- 运费  -->
                  <div class="row">{{ $t('message.freight') }}:{{ order.confirm_freight }}</div>
                </div>

              </li>
              <!-- 采购完成时间 -->
              <li>
                {{ order.order_detail_time_node != null ? order.order_detail_time_node.datetime_purchase_complete : ''
                }}
              </li>
              <!-- 交易号/物流号 -->
              <li class="flex2">
                <div class="template">
                  <!-- 物流号  -->
                  <div v-for="(purchase, purchaseIndex) in order.order_purchase" :key="purchase.id">
                    <!-- 交易号  -->
                    <div class="row">JY:{{
                      purchase.purchase_no }}</div>
                    <div class="row" v-for="(delivery, deliveryIndex) in purchase.order_purchase_express"
                      :key="deliveryIndex">WL{{ deliveryIndex + 1 }}:{{ delivery.express_no }}
                    </div>
                  </div>
                </div>
              </li>
              <!-- 业务商品备注 -->
              <li class="flex15">
                <textarea v-model="order.y_remark" @blur="updateGoodsRemark(order, order.y_remark, 1, item.order_sn)"
                  @input="allEdit(order, order.y_remark, 'y_remark')" :disabled="remark_type != 1"></textarea>
              </li>
              <!-- 业务跟单备注 -->
              <li class="flex15"><textarea v-model="order.order_detail_follow_remark.y_remark"
                  v-if="order.order_detail_follow_remark != null" :disabled="remark_type != 1"
                  @blur="updateFollowYRemark(order)"></textarea></li>
              <!-- 采购商品备注 -->
              <li class="flex15"> <textarea v-model="order.g_remark" v-if="order.order_detail_follow_remark != null"
                  @blur="updateGoodsRemark(order, order.g_remark, 2, item.order_sn, 'g_remark')"
                  @input="allEdit(order, order.g_remark, 'g_remark')" :disabled="remark_type != 2"></textarea></li>
              <!-- 采购跟单备注 -->
              <li class="flex15"> <textarea v-model="order.order_detail_follow_remark.g_remark"
                  @blur="setUpProcurementTrackingNotes(order)" :disabled="remark_type != 2"></textarea></li>
              <!-- 配货商品备注 -->
              <li class="flex15"> <textarea v-model="order.p_remark" :disabled="remark_type != 5"></textarea></li>
              <!-- 状态 -->
              <li>{{ order.status_name }}</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[20, 50, 80, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: {
        express_no: '',
        purchase_no: '',
        user_id: '',
        order_sn: '',
        g_id: '',
        y_id: '',
        p_id: '',
        org_id: '',
        admin_id: '',
        page: 1,
        pageSize: 20,
      },
      userList: [], // 人员范围
      tableData: [],// 未到货订单列表
      total: 0,// 未到货订单列表总数
      remark_type: localStorage.getItem("japanUserRoleStatus"), //工种
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  created() {
    this.getOrderFollowExpressList()
  },
  methods: {
    // 未到货订单列表
    getOrderFollowExpressList() {
      this.$api.orderApi.getOrderFollowExpressList(this.datas).then(res => {
        // 初始化订单数据
        res.data.data.forEach(item => {
          item.checked = false
          item.items.forEach(express => {
            express.checked = false
            express.order_detail.forEach(detail => {
              detail.checked = false
              detail.possible_num = 0
              detail.storage_num = 0
              // 初始化订单详情备注
              if (detail.order_detail_follow_remark == null) {
                detail.order_detail_follow_remark = {
                  y_remark: '',
                  g_remark: '',
                }
              }
              // 计算可能数量和已到数量
              detail.order_purchase.forEach(purchase => {
                detail.possible_num += purchase.possible_num - 0
                detail.storage_num += purchase.storage_num - 0
              })
            })
          })

        })
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    // 搜索
    search() {
      this.datas.page = 1
      this.getOrderFollowExpressList()
    },
    // 重置
    reset() {
      this.datas = {
        express_no: '',
        purchase_no: '',
        user_id: '',
        order_sn: '',
        g_id: '',
        y_id: '',
        p_id: '',
        org_id: '',
        admin_id: '',
        page: 1,
        pageSize: 20,
      }
      this.getOrderFollowExpressList()
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.admin_id = "";
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.getOrderFollowExpressList();
    },
    // 分页
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.getOrderFollowExpressList();
    },
    // 全选
    changeChecked(item) {
      if (item.checked) {
        item.order_detail.forEach(order => {
          order.checked = true
        })
      } else {
        item.order_detail.forEach(order => {
          order.checked = false
        })
      }
    },
    // 子项选择
    orderChangeChecked(item, order) {
      item.checked = item.order_detail.every(order => order.checked)
    },
    //同步修改
    allEdit(data, value, remarkType) {
      if (data.checked) {
        this.tableData.forEach(express => {
          express.items.forEach(order => {
            order.order_detail.forEach(itemss => {
              if (itemss.checked) {
                itemss[remarkType] = value
              }
            })
          })
        })

      }
    },
    //修改备注
    updateGoodsRemark(item, remark, type, order_sn,) {
      let datas = {
        order_sn: order_sn,
        remark,
        order_detail_id_set: [],
        remark_type: type
      }
      if (item.checked) {

        this.tableData.forEach(express => {
          express.items.forEach(order => {
            order.order_detail.forEach(itemss => {
              if (itemss.checked) {
                datas.order_detail_id_set.push(itemss.id)
              }
            })
          })
        })
      } else {
        datas.order_detail_id_set = [item.id]
      }
      this.$api.orderApi.updateGoodsRemark(datas)
    },
    // 设置采购跟单备注
    setUpProcurementTrackingNotes(data) {
      let datas = {
        g_remark: data.order_detail_follow_remark.g_remark,
        order_detail_id_set: []
      }
      //当前勾选的全部勾选修改
      if (data.checked) {
        this.tableData.forEach(express => {
          express.items.forEach(order => {
            order.order_detail.forEach(itemss => {
              if (itemss.checked) {
                datas.order_detail_id_set.push(itemss.id)
              }
            })
          })
        })
      } else { // 没有勾选的当单修改
        datas.order_detail_id_set = [data.id]
      }
      this.$api.orderApi
        .updateFollowGRemark(datas)
        .then((res) => {
          // 不刷新页面直接填充
          this.tableData.forEach(express => {
            express.items.forEach(order => {
              order.order_detail.forEach(itemss => {
                datas.order_detail_id_set.forEach(orderId => {
                  if (itemss.id == orderId) {
                    itemss.order_detail_follow_remark.g_remark = data.order_detail_follow_remark.g_remark
                  }
                })
              })
            })
          })
          this.$forceUpdate()
        });
    },
    // 跟单备注
    updateFollowYRemark(data) {
      let datas = {
        y_remark: data.order_detail_follow_remark.y_remark,
        order_detail_id_set: []
      }
      //当前勾选的全部勾选修改
      if (data.checked) {
        this.tableData.forEach(express => {
          express.items.forEach(order => {
            order.order_detail.forEach(itemss => {
              if (itemss.checked) {
                datas.order_detail_id_set.push(itemss.id)
              }
            })
          })
        })
      } else { // 没有勾选的当单修改
        datas.order_detail_id_set = [data.id]
      }
      this.$api.orderApi
        .updateFollowYRemark(datas)
        .then((res) => {
          // 不刷新页面直接填充
          this.tableData.forEach(express => {
            express.items.forEach(order => {
              order.order_detail.forEach(itemss => {
                datas.order_detail_id_set.forEach(orderId => {
                  if (itemss.id == orderId) {
                    itemss.order_detail_follow_remark.y_remark = data.order_detail_follow_remark.y_remark
                  }
                })
              })
            })
          })
          this.$forceUpdate()
        });
    },
    // 物流号--单个物流号实际物流状态
    expressStatusReal(express_no, expressIndex) {
      this.$api.orderApi.expressStatusReal({ express_no }).then((res) => {
        res.data.forEach(item => {
          if (item.statusChanged == 'CONSIGN') {
            this.tableData[expressIndex].send_time = item.updatetime
          } else if (item.statusChanged == 'SIGN') {
            this.tableData[expressIndex].receive_time = item.updatetime
          }

        })
        this.$forceUpdate()
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.breadcrumb {
  position: relative;

  .text {
    position: absolute;
    bottom: 12px;
    left: 220px;
  }

}

.search {

  .row {
    display: flex;
  }

  .item {
    margin-right: 24px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }
}

.table {
  margin-top: 24px;
  position: relative;

  li {
    margin-right: 3px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;
    padding: 6px 0;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;

    textarea {
      width: 95%;
      border-radius: 4px;
      height: 100px;
      border: 1px solid #ccc;
      resize: none;
      padding: 2px;
      color: #606266;
      font-size: 14px;
    }
  }

  .flex2 {
    flex: 2;
  }

  .express {
    .express-head {
      display: flex;
      padding: 12px;
      background-color: #dedeef;
      border-radius: 4px 4px 0 0;


      .item {
        width: 300px;
        margin-right: 24px;
        cursor: pointer;
      }

      .express_no {
        font-size: 18px;
        width: 350px;
      }
    }
  }

  .detail {
    .head {
      display: flex;
      padding: 6px 6px 6px 20px;

      background-color: #545467;
      color: #fff;

      .item {
        margin-right: 24px;
        display: flex;
        justify-content: center;
        align-items: center;

        .row {
          height: 25px;
          line-height: 25px;
          display: flex;

          a {
            color: #f0ef70;
            text-decoration: underline;
          }
        }

      }

      .order {
        justify-content: start;
        width: 250px;
      }

      .name {
        justify-content: start;
        width: 120px;
      }
    }
  }

  ul {
    li {
      text-align: center;
    }

    .template {
      width: 100%;
      text-align: left;

      .row {
        margin-bottom: 6px;
        word-break: break-all;
      }
    }
  }
}

.annotation {
  font-size: 14px;
  color: #b4272d;
}
</style>
